import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button
} from 'reactstrap';
import {decFlowKey, incFlowKey, setFlowKey} from "../../../store/actions/display";

class FlowButton extends Component {

    onClick = () => {
        if (this.props.onClick === 'inc') {
            this.props.incFlowKey(this.props.id);
        } else if (this.props.onClick === 'dec') {
            this.props.decFlowKey(this.props.id);
        } else if (this.props.onClick) {
            this.props.setFlowKey(this.props.id, parseInt(this.props.onClick, 10));
        }
    };

    render() {
        const {active, block, children, className, color, disabled, outline, size, style} = this.props;

        return (
            <Button active={active}
                    block={block}
                    className={className}
                    color={color}
                    disabled={disabled}
                    outline={outline}
                    size={size}
                    style={style}
                    onClick={this.onClick}>
                {children}
            </Button>
        );
    }
}

FlowButton.propTypes = {
    id: PropTypes.string.isRequired
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    incFlowKey(id) {
        dispatch(incFlowKey(id));
    },
    decFlowKey(id) {
        dispatch(decFlowKey(id));
    },
    setFlowKey(id, value) {
        dispatch(setFlowKey(id, value));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(FlowButton);


// WEBPACK FOOTER //
// ./src/components/flow/PolyFlow/FlowButton.js